<app-web-integration *ngIf="english"></app-web-integration>
<app-web-integration-hindi *ngIf="hindi"></app-web-integration-hindi>